// AuthenticatedRoute.js
import React, { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import { AuthenticationState } from "react-aad-msal";

import NavigationContainer from "../navigation/Navigation";
import { verifyUser } from "../api/users";
import { clearAll } from "../utilities/localstorage";
import { useUserContext } from "../context/UserContext";
import { VALID_NIAGARA_EMAIL_ID } from "../constants/ShipmentConstants";
import { removeAxiosInterceptor } from "../api/axios";
import LoadingSpinner from "./Reusables/LoadingSpinner";
import { APP_CONSTANTS } from "../constants/app-constants";

const AuthenticatedRoute = ({
	logout,
	authenticationState,
	accountInfo,
	onThemeChange,
}) => {
	const { setUserDetails } = useUserContext();
	const [isLoading, setIsLoading] = useState(true);

	const isValidNiagaraEmailUser = (email) => {
		return email.toLowerCase().endsWith(VALID_NIAGARA_EMAIL_ID);
	};

    function handleLogout() {
        removeAxiosInterceptor();
        clearAll();
        logout();
    }

	useEffect(() => {
		const checkCustomerStatus = async () => {
			if (
				authenticationState === AuthenticationState.Authenticated &&
				accountInfo?.account?.userName
			) {
				try {
					const userEmail = accountInfo.account.userName.toLowerCase();
					const jwtIdToken = accountInfo?.jwtIdToken || '';

					// First check if it's a Niagara employee
					if (isValidNiagaraEmailUser(userEmail)) {
						setUserDetails({
							isCustomerUser: false,
							customerName: "",
							username: "",
							userIdToken: jwtIdToken
						});
					} else {
						// If not a Niagara employee, check if they're a valid customer
						const userRecord = await verifyUser();

						if (userRecord?.customer) {
							setUserDetails({
								isCustomerUser: true,
								customerName: userRecord.customer,
								username: userRecord.username,
								userIdToken: jwtIdToken
							});
						} else {
							// User is neither a Niagara employee nor a recognized customer
							console.error("User  not authorized");
							handleLogout(); // Force logout for unauthorized users
							return; // Exit early
						}
					}
				} catch (error) {
					console.error("Error checking customer status:", error);
					setIsLoading(false);
					handleLogout(); // Force logout on error
					return; // Exit early
				} finally {
					setIsLoading(false);
				}
			} else {
				setIsLoading(false);
			}
		};

		if (authenticationState === AuthenticationState.Authenticated) {
			checkCustomerStatus();
		} else {
			setIsLoading(false);
		}
	}, []);

	// Render loader while Customer/User check is happening
	if (isLoading) {
		return (
			<LoadingSpinner loaderMessage={APP_CONSTANTS.LOADING_MESSAGE} />
		);
	}

	return (
		<NavigationContainer
				accountInfo={accountInfo}
				onLogout={handleLogout}
				onThemeChange={onThemeChange}
			/>
	)
};

export default AuthenticatedRoute;
